(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-mw-scroll]').forEach((button) => {
      if (button.dataset.ready) return;
      button.dataset.ready = 'true';
      button.addEventListener('click', () => {
        const track = document.getElementById(button.getAttribute('aria-controls'));
        if (track) track.scrollBy({ left: Number(button.dataset.mwScroll) * track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
    });
    root.querySelectorAll('.mw-bundle').forEach((bundle) => {
      if (bundle.dataset.ready) return;
      bundle.dataset.ready = 'true';
      bundle.addEventListener('click', (event) => {
        const button = event.target.closest('[data-mw-quantity]');
        if (!button) return;
        const product = bundle.closest('[data-valmonti-product]');
        const input = product?.querySelector('input[name="quantity"]');
        if (!input) return;
        input.value = button.dataset.mwQuantity;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        product.querySelector('product-form-component')?.setAttribute('data-quantity-default', input.value);
        bundle.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      });
    });
    root.querySelectorAll('.mw-desktop-nav .mw-dropdown').forEach((dropdown) => {
      if (dropdown.dataset.ready) return;
      dropdown.dataset.ready = 'true';
      dropdown.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') dropdown.open = true; });
      dropdown.addEventListener('pointerleave', (event) => { if (event.pointerType === 'mouse' && !dropdown.contains(document.activeElement)) dropdown.open = false; });
      dropdown.addEventListener('focusout', (event) => { if (!dropdown.contains(event.relatedTarget)) dropdown.open = false; });
    });
    root.querySelectorAll('.mw-mobile-menu').forEach((menu) => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      menu.querySelector('.mw-mobile-menu__close')?.addEventListener('click', () => { menu.open = false; menu.querySelector('summary').focus(); });
      menu.addEventListener('toggle', () => {
        document.body.style.overflow = menu.open ? 'hidden' : '';
        if (menu.open) menu.querySelector('.mw-mobile-menu__close')?.focus();
      });
      menu.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab' || !menu.open) return;
        const focusable = [...menu.querySelectorAll('button,a,summary')].filter((el) => el.getClientRects().length);
        const first = focusable[1], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    });
  }
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.mw-dropdown[open],.mw-mobile-menu[open]').forEach((el) => { el.open = false; el.querySelector('summary')?.focus(); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
